import { Injectable, EventEmitter, signal } from '@angular/core';
import { map, catchError, tap, finalize } from 'rxjs/operators';
import { Router } from '@angular/router';
import { throwError, Observable, BehaviorSubject, Subject } from 'rxjs';
import { HttpResponse, HttpHeaders, HttpErrorResponse, HttpParams, HttpClient } from '@angular/common/http';
import { UtilityService } from './utility.service';
import { HttpClientService } from './http-client.service';
import { PageLoaderService } from '../ui-components/page-loader/';
import { SAPMPProfileModel } from '../models/userprofile/loginsources';
import { ENV } from '../../../../config/config';
import { LOGIN_REQUIRED } from '../../../../config/user.config';
import { PERMISSION } from '../../../../config/permission.config';
// import { LOGIN_REQUIRED } from '../../../../config/permission.config';


declare var ENV_VAR: any; // global variable set in env.js file, imported in index.html
declare var ENV_PORTAL: any; //global variable added for addp;
declare var MYATT_AGENT: any;
declare var PREMIER_LOGIN_URL: any;
declare var MYATT_LOGIN_URL: any;
declare var DMP_PREMIER_LOGIN_URL: any;
declare var DMP_FIRSTNET_LOGIN_URL: any;
declare var DMP_MYATT_LOGIN_URL: any;
declare var LOGOUT: any;
declare var GLOBAL_LOGON_URL;
declare var PREMIER_PROFILE_LOGOUT;
declare var FIRSTNET_PROFILE_LOGOUT;
declare var MYATT_PROFILE_LOGOUT;
declare var ADMIN_LOGOUT;

@Injectable()
export class AuthenticationService {
  private modalStatus = new BehaviorSubject<boolean>(false);
  public obvStep: Observable<boolean> = this.modalStatus.asObservable();
  public static User$ = new BehaviorSubject({});
  // public enrollStatus = new Subject<boolean>();
  private enrollStatusSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  public enrollStatus$: Observable<boolean> = this.enrollStatusSubject.asObservable();

  private showProfileError = new BehaviorSubject<boolean>(false);
  public obvStep2: Observable<boolean> = this.showProfileError.asObservable();

  public notify: EventEmitter<void> = new EventEmitter<void>();

  private lastLoginHistory: BehaviorSubject<any> = new BehaviorSubject<any>("");
  public lastLog: Observable<any> = this.lastLoginHistory.asObservable();

  loginSuccessUrl: String;
  is_carelogin: String;
  loginModalStatus: boolean = false;

  constructor(private utilityService: UtilityService,
    private httpClientService: HttpClientService, private http: HttpClient,
    private router: Router,
    private pageloaderService: PageLoaderService) {
    AuthenticationService.User$.next(this.initUser());
  }
  initUser() {
    const u = (localStorage.getItem('user')) ? localStorage.getItem('user') :
      (sessionStorage.getItem('user')) ? sessionStorage.getItem('user') :
        undefined;

    if (window.location.pathname.includes('home')) this.checkSession();

    return u;
  }

  checkSession() {
    let url = this.utilityService.getEnvConfig();
    url = url.viewHeaders
    let headers = new HttpHeaders();
    headers = headers.set('Accept', 'text/html');
    // this.http.get('/businessconsole/login', {
    this.http.get('restservices/sapmp/v1/profile/viewHeaders', {
      headers: headers,
      observe: "response",
      responseType: 'text'
    }).subscribe(result => {
      let u = result.headers.get('iv-user');
      if (u && u !== 'Unauthenticated') {
        AuthenticationService.User$.next('loading')
        // this.getUserDetails().subscribe(
          this.validateAndUpdateUser() // success path
          //error => this.validateAndUpdateUser() // error path);
        // );
      }
      else { AuthenticationService.User$.next(undefined) }
    })
  }

  handleErrors(error: HttpErrorResponse): Observable<boolean> {
    let errorMessage = 'Unknown error!';
    if (error.error instanceof ErrorEvent) {
      // Client-side errors
      errorMessage = `Error: ${error.error.message}`;
    } else {
      // Server-side errors
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    return throwError(errorMessage);
  }
  validateAndUpdateUser() {
    this.validateUser().pipe(catchError(this.handleErrors))
      .subscribe((res: HttpResponse<any>) =>{
        this.getUserDetails().subscribe();
      }, (error) => {
          console.log("Error getting user data from checkSession");
          AuthenticationService.User$.next(undefined)
          // this.getUserDetails().subscribe();
          // this.handleLoginError(error.status);
        }
      )
  }
  getUserDetails() {
    // let url = ENV[ENV_VAR].profilePerm;
    let url = "";
    if(location.href.includes('admin')) {
       url = ENV[ENV_VAR].profilePermAdmin;
    }else{
      url = ENV[ENV_VAR].profilePerm;
    }
    
    let headers = new HttpHeaders();
    // console.log("data===>", PERMISSION[0]['basicAuth']);
    // headers = headers.append('Authorization', 'Basic '+PERMISSION[0]['basicAuth']);
    // headers = headers.append('Authorization', sessionStorage.getItem('sapmp_jwtToken'));
    try {
      return this.httpClientService.get(url, headers)
        .pipe(
          map( // Log the result or error
            (res: any) => {
              // console.log("profile res============>",res);
              return this.setUserDetails(res.body);
            },
            error => {
              // console.log("profile error==============>",error);
              // console.log("caught up==============>");
              // alert("caught up");
              // this.handleLoginError('403');
              // AuthenticationService.User$.next(undefined)
              console.dir(error);
              // this.headerService.setlogoutHeaderChanges(true);

              // this.logout('login');

              // AuthenticationService.User$.next(undefined)
              // this.handleLoginError(error.status);
            }
          ),
          catchError(error => {
            // console.log('error occured:', error);
            // this.handleLoginError('403');
            sessionStorage.clear();
            localStorage.clear();
            throw error;
          }),
          finalize(() => {
            console.log('finalize')
          })
        );
    } catch (error) {
      console.log("profile userinfo call error===============>", error);
    }
  }
  setUserDetails(ProfileAndPerms) {
    sessionStorage.setItem('profileAndPermsInfo', JSON.stringify(ProfileAndPerms));
    //CHECK if profile is valid if not AuthenticationService.User$.next(undefined)
    if (!ProfileAndPerms || !ProfileAndPerms.jwtToken) {
      AuthenticationService.User$.next(undefined)
    }

    sessionStorage.setItem('sapmp_jwtToken', ProfileAndPerms.jwtToken);
    sessionStorage.setItem('impersonator', JSON.stringify(ProfileAndPerms.profile.impersonator));
    if (!sessionStorage.getItem('sessionId')) {
      sessionStorage.setItem('sessionId', ProfileAndPerms.profile.user.sessionId);
    }
    sessionStorage.setItem('permissions', JSON.stringify(ProfileAndPerms.permissions));
    this.setUser(new SAPMPProfileModel(ProfileAndPerms.profile));
    return true;
  }
  setDefaultUser() {
    // this.setUserDetails(SAPMPProfileModel.getUnknownUser());//code commented for DMP-25: Unknown profile issue
    // sessionStorage.setItem('initialSignupStatus', 'unknown');
    // sessionStorage.setItem('noOfDevice', 'unknown');
    sessionStorage.clear();
    localStorage.clear();
    localStorage.setItem('profileLogin', 'true');
  }

  logout(isNavigate) {
    sessionStorage.clear();
    localStorage.removeItem('dmp_unique_stubid');
    localStorage.removeItem('dmp_stubid');
    // AuthenticationService.deleteAllCookies();
    if (isNavigate) {
      this.router.navigate(['login']);
    } else {
      sessionStorage.clear();
      window.location.href = LOGOUT;
    }
    return false;
  }

  //TODO remove static member
  static logoutStatic() {
    // sessionStorage.clear();
    // AuthenticationService.deleteAllCookies();
    // sessionStorage.clear();
    //delete below cookies for admin logout
    if (ENV_PORTAL.toUpperCase() == "DMPADMIN"){
      window.location.href = ADMIN_LOGOUT;
    }else{
      window.location.href = LOGOUT;
    }
    return false;
  }

  checkIfAuthNeeded() {
    if (
      sessionStorage.getItem('sapmp_jwtToken') != null &&
      sessionStorage.getItem('permissions') != null &&
      sessionStorage.getItem('initialSignupStatus') != null
    ) {
      return true;
    }
    return false;
  }

  validateUser() {
    let payload = {};
    let ivuser = sessionStorage.getItem('iv-user');
    let stubid = sessionStorage.getItem('stubId');
    let client = sessionStorage.getItem('client');
    let rkey = sessionStorage.getItem('rkey');
    let multiStubId = localStorage.getItem('dmp_unique_stubid');
    let dmpstubId = localStorage.getItem('dmpStubId');

    let url = this.utilityService.getEnvConfig().validateUser +"?source=" + ENV_PORTAL.toUpperCase();
    if (ENV_PORTAL.toUpperCase() !== "DMPADMIN") {
      // url += (ivuser && ivuser != 'undefined') ?
      //   "&iv-user=" + ivuser : ''; //SAPMPDEV-1371 removed as iv-user is not required for validation call, from backend it is not handled.
      url += (stubid && stubid != 'undefined') ?
        "&stubId=" + stubid : '';
      url += (client && client != 'undefined') ?
        "&client=" + client : '';
      url += (rkey && rkey != 'undefined') ?
        "&rkey=" + rkey : '';
     if(multiStubId && multiStubId != 'undefined') payload["dmp_unique_stubid"] = multiStubId;
     if(dmpstubId && dmpstubId != 'undefined') payload["dmp_stubid"] = dmpstubId;
    }

    return this.httpClientService.post(url, payload).pipe(
      // return this.httpClientService.get(url).pipe(
      tap( // Log the result or error
        (data: HttpResponse<any>) => {
          console.dir(data);
          if ((dmpstubId == null || dmpstubId == undefined) && ENV_PORTAL.toUpperCase() !== "DMPADMIN") {
            //Need to add condition for multistubID
            if (data.body && data.body.body != null) {
              localStorage.setItem('dmp_stubid_list', JSON.stringify(data.body.body));
            }
            console.log("Redirected to mutistubid page");
          }
        //  sessionStorage.removeItem("dmp_unique_stubid");
        },
        error => {
          //TODO Proactivly Handle if Profile Errors
          console.dir(error);
          //sessionStorage.removeItem("dmp_unique_stubid");
          return error;
        }
      )
    );
  }

  handleLoginError(status: any) {
    //throw new Error("Method not implemented.");
    // navigate to home page with error code
    this.pageloaderService.setPageLoaderStatus(true);
    let stubId = sessionStorage.getItem('stubIdError');
    if(!stubId || stubId == 'undefined' || stubId == null) {
      this.setDefaultUser();
    }  
    localStorage.setItem('loginFail', status);
    let d = new Date();
    d.setTime(d.getTime());
    let expires = "expires=" + d.toUTCString();
    document.cookie = "profileError="+status+"; domain=.att.com; path=/";
    this.router.navigate(['home']);
  }

  navigateAfterLogin(rkey) {
    this.pageloaderService.setPageLoaderStatus(true);

    this.router.navigate(["authentication"], {
      queryParams: {
        rKey: rkey
      }
    });
  }
  //check local config if route requires only login
  isRkeyGarded(rkey) {
    return (LOGIN_REQUIRED.find(routeName => rkey == routeName) !== undefined);
  }

  handleFanError(errorCode) {
    this.pageloaderService.setPageLoaderStatus(true);
    this.router.navigate(['errorPage', errorCode]);
  }

  checkCredentials() {
    let retrievedObject = sessionStorage.getItem('user');
    if (sessionStorage.getItem('sapmp_jwtToken') === null) {
      this.router.navigate(['login']);
    }
    return JSON.parse(retrievedObject).user;
  }

  handleError = (error) => {
    return throwError(error);
  };

  setLoginSuccessUrl(url) {
    if (!url) {
      localStorage.removeItem('loginSuccessUrl');
      return;
    }
    let clearUrl = url.replace('/', '');
    localStorage.setItem('loginSuccessUrl', clearUrl);
  }

  getLoginSuccessUrl() {
    return localStorage.getItem('loginSuccessUrl');
  }

  setLoginModalStatus(value: boolean) {
    this.modalStatus.next(value);
  }

  getLoginModalStatus(): Observable<boolean> {
    return this.obvStep;
  }


  setAuthToken(tokenName, token) {
    sessionStorage.setItem(tokenName, JSON.stringify({ timestamp: new Date(), token: token }));
  }

  getAuthToken(tokenName) {
    if (sessionStorage.getItem(tokenName) === null) {
      return null;
    } else {
      return JSON.parse(sessionStorage.getItem(tokenName)).token;
    }
  }

  //only location that sets user session storage.
  setUser(applicationuser) {
    sessionStorage.setItem('user', JSON.stringify({ timestamp: new Date(), user: applicationuser }));
    //observable to sessionStorage user object changes
    AuthenticationService.User$.next(applicationuser);
  }

  getUser() {
    if (sessionStorage.getItem('user') === null) {
      return null;
    } else {
      return JSON.parse(sessionStorage.getItem('user')).user;
    }
  }
  isLoggedIn() {
    return this.getCookie('tAuthNState');
  }
  checkNDAGroup(cookieValue) {
    let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'text/json');
    headers = headers.append('attESG2', cookieValue);
    headers = headers.append('channel', 'premier');
    headers = headers.append('portal', 'appmarket');
    return this.httpClientService.post(ENV[ENV_VAR].cspGroupValidationUrl, null, headers).pipe(
      catchError(this.handleNDAError));
  }

  getTimeStamp() {
    if (sessionStorage.getItem('user') === null) {
      return null;
    } else {
      return JSON.parse(sessionStorage.getItem('user')).timestamp;
    }
  }

  handleNDAError = (error) => {
    throw error;
  };


  getPermissions() {
    if (sessionStorage.getItem('permissions') === null) {
      return null;
    } else {
      return JSON.parse(sessionStorage.getItem('permissions'));
    }
  }

  getProfile(adminAttId?: string) {
    let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'text/json');
    // headers = headers.append('Authorization', sessionStorage.getItem('sapmp_jwtToken'));
    // headers = headers.append('Authorization', 'Basic '+PERMISSION[0]['basicAuth']);
    let url = "";
    if(location.href.includes('admin')) {
       url = ENV[ENV_VAR].profilePermAdmin;
    }else{
      url = ENV[ENV_VAR].profilePerm;
    }
    return this.httpClientService.getProfile(url, headers)
      .pipe(
        map((res: HttpResponse<any>) => {
          return res.body;
        },
          error => {
            return error;
          }
        )
      );
  }

  // added to maintain the landing page url in session on success full login, based on ADDP authority and FAN signedup status
  setLandingPageRoute(route) {
    sessionStorage.setItem('landingPageRoute', route);
  }

  getLandingPageRoute() {
    let route = sessionStorage.getItem('landingPageRoute');
    if (!route) {
      route = '/login';
    }
    return String(route);
  }

  getFanSignedUpStatus() {
    let headers = new HttpHeaders();
    headers = headers.append('Authorization', sessionStorage.getItem('sapmp_jwtToken'));
    const id = sessionStorage.getItem('signupStatus');
    let url;
    url = ENV[ENV_VAR].dashboardSummary;

    return this.httpClientService.get(url, headers)
      .pipe(
        map((res: HttpResponse<any>) => {
          return res.body 
          }),
        catchError(this.handleNDAError));
  }

  getSubscriptionData(subUrl, requestData) {
    return this.httpClientService.authorizedPut(subUrl, requestData)
      .pipe(
        map((res: HttpResponse<any>) => {
          if (sessionStorage.getItem('sapmp_jwtToken') != null) {
            this.httpClientService.tokenRefresh(this.utilityService.getEnvConfig().tokenRefresh);
          }
          return res.body;
        })
        , catchError(this.handleError));
  }

  getProfileModel(profile) {
    return new SAPMPProfileModel(profile);
  }

  getHaloAuthenticateState(url) {
    return this.httpClientService
      .authorizedGet(url, null, 'text')
      // .get(url)
      .pipe(
        map((res: HttpResponse<any>) => {
          this.httpClientService.updateAuthorizationHeaders(res);
          let data = res.body;
          // let data = 'UNAUTHENTICATE';
          let isHaloStatus: boolean;
          if (data === 'CONTINUE') {
            isHaloStatus = true;
          } else if (data === 'AUTHENTICATE') {
            isHaloStatus = false;
          }
          else if (data === 'UNAUTHENTICATE') {
            isHaloStatus = null;
          }
          return isHaloStatus;
        })
        , catchError(this.handleError));
  }


  careServiceLogin(user, redirectUrl) {
    sessionStorage.removeItem('authToken');
    let fanId = user;
    let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'text/json');
    headers = headers.append('portal', 'appmarket');
    headers = headers.append('channel', 'care');
    headers = headers.append('fanNumber', fanId);
    headers = headers.append('client', sessionStorage.getItem('client'));
    let url = '';
    url = this.utilityService.getEnvConfig().careAuthTokenWithoutFanIdServiceUrl; //+'&rdirect=true&source=care&rKey=dashboard';
    return this.httpClientService.get(url, headers) //need to change param (url, headers ) in case of actual api call
      .pipe(
        map((res: HttpResponse<any>) => { return res.body }),
        catchError(this.handleNDAError));
  }

  careUserProfile() {
    let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'text/json');
    headers = headers.append('portal', 'appmarket');
    headers = headers.append('channel', 'care');
    let url = '';
    if (!this.utilityService.getEnvConfig().useMock) {
      url = this.utilityService.getEnvConfig().careUserProfileUrl;
    }
    else {
      url = this.utilityService.getEnvConfig().careUserProfileUrlMock;
    }
    // let userProfileURL = this.utilityService.getEnvConfig().careUserProfileUrl;
    return this.httpClientService.authorizedGet(url, headers)
      .pipe(
        map((res: HttpResponse<any>) => { return res.body }),
        catchError(this.handleNDAError));
  }
  careServiceLoginNoID(redirectUrl) {
    sessionStorage.removeItem('authToken');
    // let fanId = user;
    let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'text/json');
    headers = headers.append('portal', 'appmarket');
    headers = headers.append('channel', 'care');
    headers = headers.append('client', sessionStorage.getItem('client'));
    let url = '';
    url = this.utilityService.getEnvConfig().careAuthTokenWithoutFanIdServiceUrl;//+'&rdirect=true&source=care&rKey=dashboard';
    return this.httpClientService.get(url, headers) //need to change param (url, headers ) in case of actual api call
      .pipe(
        map((res: HttpResponse<any>) => { return res.body }),
        catchError(this.handleNDAError));
  }

  gloablLogin() {
    const ADDP_PROTAL_PATHNAME = window.location.href;
    const ADDP_RETURN_URL_ENCODED = encodeURIComponent(ADDP_PROTAL_PATHNAME);
    const GOLBAL_LOGON_CALLING_URI = GLOBAL_LOGON_URL + ADDP_RETURN_URL_ENCODED + '&encReturnURL&sysName=CSP';
    this.pageloaderService.setPageLoaderStatus(false);
    // window.location.href = GOLBAL_LOGON_CALLING_URI;
    // this.pageloaderService.setPageLoaderStatus(true);
    // MFA fixes added for halo.e junction integration
    window.location.href = ADDP_PROTAL_PATHNAME;
  }

  static deleteAllCookies() {
    document.cookie.split(';').forEach(cookie =>
      document.cookie = cookie + "=;expires="
      + new Date(0).toUTCString()
    );
  }
  getCookie(cname) {
    const name = cname + '=';
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return null;
  }

  loginDirect(portal) {
    let profileErrorStatus = localStorage.getItem('profileLogin')? JSON.parse(localStorage.getItem('profileLogin')) : false;
    if(profileErrorStatus){
        localStorage.clear();
        if(portal === 'sapmp'){
          window.location.href = PREMIER_PROFILE_LOGOUT;
        }else if(portal == 'fnabc'){
          window.location.href = FIRSTNET_PROFILE_LOGOUT;
        }else{
          window.location.href = MYATT_PROFILE_LOGOUT;
        }
    }else{
      const domain = (portal === 'sapmp') ? DMP_PREMIER_LOGIN_URL
        : (portal === 'fnabc') ? DMP_FIRSTNET_LOGIN_URL : DMP_MYATT_LOGIN_URL;
      const loginSuccessUrl = this.getLoginSuccessUrl();
      window.location.href = domain;
    }
  }

  // setProfileErrorModalStatus(value: boolean) {
  //   this.showProfileError.next(value);
  //   this.router.navigate(['/home']);
  // }

  // getProfileErrorModalStatus(): Observable<boolean> {
  //   return this.obvStep2;
  // }

  updateEnrollStatus(data: any) {
    let activeSignup = data.fanInfoList && data.fanInfoList.length > 0 ? data.fanInfoList.filter(fan => fan.accountStatus === 'ACTIVE' || fan.accountStatus === 'SIGNUP_INPROGRESS').length : 0;
    if(data.showEnroll){
      this.enrollStatusSubject.next(true);
    }else{
      if(data.noOfFans !=0 && activeSignup !=0){
        if(activeSignup >= data.noOfFans * 3){
          //hide Register/Enroll menu
          this.enrollStatusSubject.next(false);
        }else{
          //show Register/Enroll menu
          this.enrollStatusSubject.next(true);
        }
      }else if(data.noOfFans != 0 && activeSignup == 0){
        this.enrollStatusSubject.next(true);
      }
    }
    
    // this.enrollStatusSubject.next(status);
  }
  
  getEnrollStatus() {
    return this.enrollStatusSubject.asObservable();
  }

  getLastLoginHistory(): Observable<any>{
    let headers = new HttpHeaders();
    // headers = headers.append('Authorization', sessionStorage.getItem('sapmp_jwtToken'));
    // headers = headers.append('Authorization', 'Basic '+PERMISSION[0]['basicAuth']);
    let url = this.utilityService.getEnvConfig().getLoginHistory;
    return this.httpClientService.get(url, headers)
      .pipe(
        map((res: HttpResponse<any>) => {
          // if (sessionStorage.getItem('sapmp_jwtToken') != null) {
          //   this.httpClientService.tokenRefresh(this.utilityService.getEnvConfig().tokenRefresh);
          // }
          // this.lastLoginHistory.next(res.body);
          return res.body;
        })
        , catchError(this.handleError));
  }

  // setLastLoginHistory(data: any) {
  //   this.lastLoginHistory.next(data);
  // }

  getLastLoginHistoryData(): Observable<any> {
    return this.lastLog;
  }
}
